import 'angular:locale/data:zh';
import 'angular:locale/data:vi';
import 'angular:locale/data:uk';
import 'angular:locale/data:tr';
import 'angular:locale/data:th';
import 'angular:locale/data:sw';
import 'angular:locale/data:sv';
import 'angular:locale/data:sq';
import 'angular:locale/data:sl';
import 'angular:locale/data:ro';
import 'angular:locale/data:pt';
import 'angular:locale/data:pl';
import 'angular:locale/data:nl';
import 'angular:locale/data:nb';
import 'angular:locale/data:ms';
import 'angular:locale/data:ko';
import 'angular:locale/data:ja';
import 'angular:locale/data:it';
import 'angular:locale/data:id';
import 'angular:locale/data:hu';
import 'angular:locale/data:hi';
import 'angular:locale/data:fr';
import 'angular:locale/data:fil';
import 'angular:locale/data:fi';
import 'angular:locale/data:es';
import 'angular:locale/data:el';
import 'angular:locale/data:de';
import 'angular:locale/data:da';
import 'angular:locale/data:cs';
import 'angular:locale/data:ca';
import 'angular:locale/data:bn';
import 'angular:locale/data:af';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
